import { i18n } from 'i18n';
import { useContext } from 'react';
import SceneManagerContext from './sceneManagerContext';

const useSceneManager = () => {
  const context = useContext(SceneManagerContext);
  if (context === null) {
    throw new Error(i18n._('No sceneManager context available'));
  }
  return context;
};

export default useSceneManager;
